import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
	createResource,
	deleteResource,
	fetchResources,
	updateResource,
} from "@/api/resources";

export const useResources = () => {
	const queryClient = useQueryClient();

	const { data, error, status } = useQuery({
		queryKey: ["resources"],
		queryFn: fetchResources,
	});

	const createResourceMutation = useMutation({
		mutationFn: createResource,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["resources"] });
		},
	});

	const updateResourceMutation = useMutation({
		mutationFn: ({
			id,
			resource,
		}: {
			id: number;
			resource: Parameters<typeof updateResource>[1];
		}) => updateResource(id, resource),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["resources"] });
		},
	});

	const deleteResourceMutation = useMutation({
		mutationFn: deleteResource,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["resources"] });
		},
	});

	return {
		resourceRequest: {
			data: data || [],
			status: status === "pending" ? "loading" : status,
			message: error instanceof Error ? error.message : null,
		},
		createResource: createResourceMutation.mutateAsync,
		updateResource: updateResourceMutation.mutateAsync,
		deleteResource: deleteResourceMutation.mutateAsync,
	};
};
